<div *ngIf="isGenerating">
    <div class="loader is-active padding-leader-3 padding-trailer-3">
        <div class="loader-bars"></div>
        <div class="loader-text">Loading...</div>
    </div>
</div>
<div class="alert alert-red is-active container" *ngIf="error">
    {{ errorMessage }}
</div>
<div class="bootstrap-wrapper">
    <div *ngIf="reportData" id="onemap-report" class="iri-project-evaluation-tip-report">
        <div class="header">
            <h2>IRI Project Evaluation TIP Report</h2>
            <b>Date: {{ todaysDate }}</b>
            <hr>
        </div>
        <div>
            <b>Search Location:&nbsp;</b>{{ searchLocation }}<br>
            <b>Total Miles:&nbsp;</b>{{ totalMiles }}
        </div>
        <table class="table table-bordered table-condensed" aria-label="IRI Project Evaluation TIP Report">
            <thead>
                <tr>
                    <th>IRI Ratings</th>
                    <th>Miles</th>
                    <th>Percentage of Total Miles</th>
                    <th>Total Miles Addressed</th>
                    <th>% Addressed by Projects</th>
                    <th>Miles not Addressed</th>
                    <th>% Not Addressed</th>
                </tr>
            </thead>
            <tr *ngFor="let row of reportData.projectEvaluationSummary" class="{{ row.rating | lowercase }}">
                <td>{{ row.rating }}</td>
                <td>{{ row.miles }}</td>
                <td>{{ row.pctMilesTotal }}</td>
                <td>{{ row.prjMiles }}</td>
                <td>{{ row.pctPrjMiles }}</td>
                <td>{{ row.notAddressed }}</td>
                <td>{{ row.pctNotAddressed }}</td>
            </tr>
        </table>
        <div class="summary-info">
            This report calculates the total percentage of miles within the search area that have IRI being addressed in the TIP or Draft
            TIP. This summary shows total conditions being addressed in the search area. To see specific project and IRI data,
            please see the IRI Detail sheet.
        </div>
        <div class="header">
            <h3>IRI Details</h3>
            <table class="legend" aria-label="IRI Details legend">
                <tr style="display:none;">
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
                <tr>
                    <td class="poor">Poor</td>
                    <td class="fair">Fair</td>
                    <td class="good">Good</td>
                    <td class="excellent">Excellent</td>
                </tr>
            </table>
        </div>
        <table class="table table-bordered table-condensed" aria-label="IRI Details">
            <thead>
                <tr>
                    <th>Project ID</th>
                    <th>Planning Partner</th>
                    <th>Improvement Type</th>
                    <th>County Name</th>
                    <th>Route</th>
                    <th>Segment</th>
                    <th>Miles</th>
                    <th>Let Indicator</th>
                    <th>Let Date</th>
                    <th>% Addressed</th>
                    <th>Estimated Cost for Construction</th>
                </tr>
            </thead>
            <tr *ngFor="let row of reportData.projectEvaluationDetails" class="{{ row.rating | lowercase }}">
                <td><a href="?projectId={{ row.projectId }}" target="blank">{{ row.projectId }}</a></td>
                <td>{{ row.planningPartnerShortName }}</td>
                <td>{{ row.improvementType }}</td>
                <td>{{ row.countyName }}</td>
                <td>{{ row.stRtNo }}</td>
                <td>{{ row.segNo }}</td>
                <td>{{ row.segmentMiles }}</td>
                <td>{{ row.letFlag }}</td>
                <td>{{ row.letDate }}</td>
                <td>{{ row.percentOfProject }}</td>
                <td>{{ row.estimatedConstructionCost | currency }}</td>
            </tr>
        </table>
    </div>
</div>
